export enum PDPEvents {
  Intro = 'intro',
  ZeemaAssess = 'zima_assess',
  Documents = 'documents',
  Timing = 'timing',
  AdvancedReporting = 'advanced_reporting',
  FaraboorsInquiry = 'faraboors_inquiry',
  Calculator = 'calculator',
  Counseling = 'counseling',
  CounselingCall = 'counseling_call',
  Investing = 'investing',
  ModalSignupLogin = 'modal_signupLogin',
  SejamSync = 'sajam_sync',
  SejamSignup = 'sajam_signup',
  InvestmentSuccess = 'invsetment_success',
}
export enum HeaderEvents {
  Plans = 'plans',
  MyPlans = 'my_plans',
  InvestRequest = 'invest_request',
  About = 'about',
  Blog = 'blog',
  NavBarSignup = 'navBar_signup',
  ProfileIcon = 'profile_icon',
}
